import { Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { SectionTimerBannerAttributes } from 'core/flow/entities';
import { useResolution } from 'core/theme/hooks';
import { ButtonAnimation } from 'core/theme/ui/button';
import { Timer } from './Timer';
import {
  ButtonStyled,
  ContentBlockStyled,
  TimerContainerStyled,
  TimerWrapperStyled,
} from './styled';

export type TimerBannerProps = {
  onScrollToBlock: () => void;
  onTimeUp: () => void;
  content: SectionTimerBannerAttributes['content'];
};

export const TimerBanner = ({ onTimeUp, content, onScrollToBlock }: TimerBannerProps) => {
  const { bannerTitle, seconds, minutes, buttonText } = content;
  const { isMobileResolution } = useResolution();

  const ContentBlock = isMobileResolution ? (
    <ContentBlockStyled>
      <Typography
        variant="bodyExtraSmallSemiBold"
        dangerouslySetInnerHTML={prepareHtml(bannerTitle)}
      />
      <Timer onTimeUp={onTimeUp} labels={{ seconds, minutes }} />
    </ContentBlockStyled>
  ) : (
    <>
      <Typography
        variant="bodyExtraSmallSemiBold"
        dangerouslySetInnerHTML={prepareHtml(bannerTitle)}
      />
      <Timer onTimeUp={onTimeUp} labels={{ seconds, minutes }} />
    </>
  );

  return (
    <TimerWrapperStyled>
      <TimerContainerStyled maxWidth="container">
        {ContentBlock}
        <ButtonStyled
          animation={ButtonAnimation.SHINE}
          size="small"
          variant="contained"
          onClick={onScrollToBlock}
        >
          {buttonText}
        </ButtonStyled>
      </TimerContainerStyled>
    </TimerWrapperStyled>
  );
};
